// Project: GSSC Pilot Front-end
// Filename: main.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
